export default __webpack_public_path__ + "static/pigeon-look-desktop@2x-c66f0ea0fe23271fe7738cae6729062e.png";